export default "__VITE_ASSET__DhQXAkhd__"